import { useEffect, useState } from "react";
import { csuiteAuth } from "./csuiteApi";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function postJson(path, body, auth = false) {
  const headers = { "Content-Type": "application/json" };
  if (auth && csuiteAuth.getToken()) headers.Authorization = `Bearer ${csuiteAuth.getToken()}`;
  const r = await fetch(`${API}${path}`, { method: "POST", headers, body: JSON.stringify(body || {}) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(typeof d.detail === "string" ? d.detail : "Something went wrong. Please try again.");
  return d;
}

export function useAiGuides() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    fetch(`${API}/guides`).then((r) => r.json()).then((d) => setItems(d.items || [])).catch(() => {});
  }, []);
  return items;
}

export function useAiGuide(slug, skip) {
  const [state, setState] = useState({ loading: !skip, guide: null });
  useEffect(() => {
    if (skip) return;
    setState({ loading: true, guide: null });
    fetch(`${API}/guides/${encodeURIComponent(slug)}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((g) => setState({ loading: false, guide: g ? { ...g, related: [] } : null }))
      .catch(() => setState({ loading: false, guide: null }));
  }, [slug, skip]);
  return state;
}
